import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

import { useNotifyPartnersDividendsModal } from '../context/NotifyPartnersDividendsModalContext';

const PartnersTableViewHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useNotifyPartnersDividendsModal();

  const columns = [
    {
      key: 'partners',
      content: t('Partners'),
    },

    {
      key: 'action',
      content: (
        <button
          type="button"
          className="badge btn-primary"
          onClick={actions.handleChangeView}
        >
          <em className={`icon ni ni-chevron-${data.expandDirection}`} />
        </button>
      ),
      textPosition: 'right',
    },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default PartnersTableViewHeader;
